import React from "react";
import tw from "twin.macro";
import styled, { css } from "styled-components";

const Container = styled.div`
  ${tw`relative -mx-8 font-work_sans`}
  padding-top: clamp(2.5rem, 2rem + 2vw, 4rem);
`;
const TwoColumn = tw.div`flex flex-col lg:flex-row bg-[#FFFBDC] text-gray-900 min-h-screen`;

const LeftColumn = tw.div`px-8 xl:pl-12 pt-10 pb-16 lg:w-1/2 flex flex-col justify-center min-h-[50vh] lg:min-h-0`;

const RightColumn = styled.div(({ $bg }) => css`
  ${tw`w-full`}
  position: relative;
  flex: 1 1 auto;
  min-height: 50vh;
  background-color: #fffbdc;
  background-image: url("${$bg}");
  background-size: cover;
  background-position: center;

  @media (min-width: 1024px) {
    flex: none;
    width: 50%;
    min-height: auto;
    background-image: none;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6rem 0;
  }
`);

const ImageBox = styled.div(({ $bg }) => css`
  display: none;

  @media (min-width: 1024px) {
    display: block;
    width: 78%;
    aspect-ratio: 4 / 5;
    border-radius: 30px;
    overflow: hidden;
    background-image: url("${$bg}");
    background-size: cover;
    background-position: center;
    box-shadow: 0 32px 60px rgba(20, 19, 65, 0.16);
  }
`);

const Content = tw.div`mt-2 lg:mt-6 mb-6 flex flex-col items-start text-left`;

const Heading = styled.h1`
  ${tw`text-3xl sm:text-5xl md:text-6xl tracking-tight uppercase`}
  line-height: 0.9;
  @media (min-width: 768px) {
    line-height: 1;
  }
`;

const Paragraph = styled.p`
  ${tw`mt-6 lg:mt-10 leading-snug text-base sm:text-lg`}
  max-width: 44rem;
`;

const ButtonRow = tw.div`mt-10 flex flex-wrap items-center gap-4`;

const PrimaryButton = styled.a`
  ${tw`inline-flex items-center justify-center uppercase font-semibold`}
  padding: 0.85rem 2.8rem;
  border-radius: 999px;
  background: #14133b;
  color: #fffbdc;
  text-decoration: none;
  letter-spacing: 0.08em;

`;

const SecondaryButton = styled.a`
  ${tw`inline-flex items-center justify-center uppercase font-semibold`}
  padding: 0.85rem 2.6rem;
  border-radius: 999px;
  border: 1.5px solid #14133b;
  background: rgba(255, 251, 220, 0.92);
  color: #14133b;
  text-decoration: none;
  letter-spacing: 0.08em;
  
`;

const SupportingText = styled.p`
  ${tw`mt-4 text-sm sm:text-base text-gray-700`}
  max-width: 36rem;
`;

const CateringComponent = ({
  onQuoteClick,
  menuUrl = "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/Catering%20Menu%20V1.pdf",
  rightImage = "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/MENU/bowl%20pictures_square/catering.jpg",
}) => {
  return (
    <Container>
      <TwoColumn>
        <LeftColumn>
          <Content>
            <Heading>
              <span>CATER A TEAM</span>
              <br />
              <span>WE'RE HERE TO</span>
              <br />
              <span>MAKE IT EASY.</span>
            </Heading>

            <Paragraph>
              From office lunches to corporate offsites and casual gatherings, our catering specialists bring the Healthy. Hearty. Honest. flavours of Grain straight to your guests.
            </Paragraph>
            <SupportingText>
              We tailor menus around your headcount, dietary preferences, and budget so every bowl lands just right.
            </SupportingText>

            <ButtonRow>
              <PrimaryButton
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  onQuoteClick?.();
                }}
              >
                Quote Now
              </PrimaryButton>
              <SecondaryButton href={menuUrl}>Download Menu</SecondaryButton>
            </ButtonRow>
          </Content>
        </LeftColumn>

        <RightColumn $bg={rightImage}>
          <ImageBox $bg={rightImage} aria-hidden="true" />
        </RightColumn>
      </TwoColumn>
    </Container>
  );
};

export default CateringComponent;
